import React, { Component } from 'react'
import PropTypes from 'prop-types'

class Webcam extends Component {
  componentDidMount() {
    const { width, height } = this.props
    navigator.mediaDevices.getUserMedia({
      audio: false,
      video: { width, height },
    })
      .then(this.success)
      .catch(console.error)

    this.interval = setInterval(() => {
      this.capture()
    }, this.props.interval)
  }
  componentWillUnmount() {
    clearInterval(this.interval)
    this.video.srcObject.getTracks().forEach(track => track.stop())
  }
  success = (stream) => {
    this.video.srcObject = stream
  }
  capture = () => {
    const { width, height } = this.props
    const canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height

    const context = canvas.getContext('2d')
    context.save()
    context.scale(-1, 1)
    context.drawImage(this.video, canvas.width * -1, 0, canvas.width, canvas.height)
    context.restore()
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height)
    const dataURL = canvas.toDataURL('image/jpeg', 0.6)
    this.props.onCapture(dataURL, imageData)
  }
  render() {
    /* eslint jsx-a11y/media-has-caption: 0 */
    return (
      <video ref={(video) => { this.video = video }} autoPlay style={{ transform: 'scaleX(-1)' }} />
    )
  }
}
Webcam.propTypes = {
  onCapture: PropTypes.func.isRequired,
  interval: PropTypes.number.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
}
Webcam.defaultProps = {
  width: 1280,
  height: 720,
}

export default Webcam



// WEBPACK FOOTER //
// ./src/components/Webcam.js